import { useReferrals } from "@bounce/referrals"

import type { GetStoreLocationQuery } from "@/libs/bounce/bounceSdk.types.gen"
import { useUrl } from "@/libs/router"
import { useAppURL } from "@/utils/appURL"

type UseBookNowUrlOptions = {
  store: Pick<GetStoreLocationQuery["store"], "id" | "city" | "type">
}

export const useBookNowUrl = ({ store }: UseBookNowUrlOptions) => {
  const { getUrl } = useUrl()
  const buildAppURL = useAppURL()
  const { coupon } = useReferrals.useCodes()
  const isLocker = store.type === "Locker"

  const basePath = `/s/location/${store.id}`
  const path = isLocker ? basePath : `${basePath}/book`
  const options = { query: store.city.query, coupon }

  return {
    path,
    url: buildAppURL(getUrl({ path }), options),
  }
}
